import Model from './Model'

export default class RevitElementModel extends Model {
  public id: number|undefined

  resource () : string {
    return 'revit-elements'
  }
}
